export default {
  init() {
    // Height

    function setEqualHeight(selector) {
      var elements = document.querySelectorAll(selector);
      var maxHeight = 0;
      for (var i = 0; i < elements.length; i++) {
        var elementHeight = elements[i].clientHeight;
        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      }
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.height = maxHeight + "px";
      }
    }

    setEqualHeight(".box");
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js